import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatKpiBarItem = createCustomElementWrapper('kat-kpi-bar-item', 'KatKpiBarItem', {
    'secondaryLabel': 'secondary-label',
    'showControlIcon': 'show-control-icon',
    'trendPolarity': 'trend-polarity',
}, {
    'onControlClick': 'controlClick',
}, [
    'error',
]);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/katal-react/es/kpi-bar-item.js
// module id = 1262
// module chunks = 0